import { Card, Icon } from "@fanduel/og-fe-library";
import cx from "classnames";
import { useState } from "react";
import NumberFireLogo from "@/components/svg/NumberFireLogo";
import styles from "./numberFireVerdict.module.scss";

interface NumberFireVerdictProps {
  verdict: string;
}

const NumberFireVerdict = ({ verdict }: NumberFireVerdictProps) => {
  const [showTooltip, toggleTooltip] = useState(false);
  return (
    <Card variant="elevation" elevation="mid">
      <div className={styles.header}>
        <div className={styles.toolTipContainer}>
          <Icon
            iconName="icons.information"
            iconColor="colorBaseBlueDarken1"
            onClick={() => toggleTooltip((val) => !val)}
          />
          <div className={cx(styles.tooltip, !showTooltip && styles.hidden)}>
            <p>
              All race stats and comments are provided by numberfire. Complex
              algorithms are used to calculate stats like the power rating.
              Numberfire picks are provided by horse racing experts that work
              with numberfire.
            </p>
            <Icon
              iconName="icons.cross"
              iconColor="colorBaseNavyDefault"
              onClick={() => toggleTooltip(false)}
            />
          </div>
        </div>
        <NumberFireLogo />
        <p>Verdict</p>
      </div>
      <div className={styles.body}>{verdict}</div>
    </Card>
  );
};

export default NumberFireVerdict;
